import BaseItemSerializer from './base-item';

export default class LlSerializer extends BaseItemSerializer {}
